<div id="layout" class="theme-cyan">
  <app-project-leftmenu></app-project-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="avatar sm">
                  <a [routerLink]="['/app-project-invoice']" href="javascript:void(0)" title="" class="link"><i
                      class="zmdi zmdi-arrow-left zmdi-hc-lg"></i></a>
                </div>
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Create Invoices</h5>
                  </div>
                  <small class="text-truncate text-muted">Description text here...</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">
              <ul class="nav justify-content-end d-inline-flex">
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <a href="javascript:void(0)" class="nav-link text-muted px-3" (click)="isCollapsed = !isCollapsed"
                    [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic" title="Search this chat">
                    <i class="zmdi zmdi-search zmdi-hc-lg"></i>
                  </a>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <button class="btn btn-default" type="button"><i class="zmdi zmdi-mail-send me-2"></i>Send
                    invoice</button>
                </li>
                <li class="nav-item list-inline-item d-none d-md-block me-2">
                  <button class="btn btn-default" type="button"><i class="zmdi zmdi-download me-2"></i>Download</button>
                </li>

                <!-- Mobile nav -->
                <li class="nav-item list-inline-item d-block d-sm-none px-3">
                  <div class="dropdown">
                    <a class="nav-link text-muted px-0" href="javascript:void(0)" data-bs-toggle="dropdown"
                      aria-haspopup="true" aria-expanded="false">
                      <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0)">Send invoice</a>
                      <a class="dropdown-item" href="javascript:void(0)">Download</a>
                    </div>
                  </div>
                </li>
                <!-- Mobile nav -->
              </ul>
            </div>

          </div>

        </div>
      </div>

      <!-- Body: Search -->
      <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
        <div class="container-fluid py-2">

          <div class="row">
            <div class="input-group">
              <input type="text" class="form-control" placeholder="Search...">
              <div class="input-group-append">
                <span class="input-group-text text-muted"><small>0 / 0</small></span>
              </div>
              <div class="input-group-append dropdown" dropdown placement="bottom right">
                <button type="button" class="btn btn-secondary">Search</button>


                <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                  class="btn btn-secondary dropdown-toggle dropdown-toggle-split ml-1">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                  aria-labelledby="button-basic">
                  <a href="javascript:void(0);" class="dropdown-item">Action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                  <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a class="dropdown-item" href="javascript:void(0)">Separated link</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container-fluid">

          <div class="row">
            <div class="col-lg-12 col-md-12">

              <!-- Card: -->
              <div class="card mb-3">
                <div class="card-body">
                  <div class="row align-items-cente">
                    <div class="col-lg-4 col-md-6">
                      <select class="form-control">
                        <option label="empty"></option>
                        <option value="currency1" selected="">USD (United States Dollar)</option>
                        <option value="currency2">GBP (United Kingdom Pound)</option>
                        <option value="currency3">Euro (Euro Member Countries)</option>
                      </select>
                    </div>
                    <div class="col-lg-8 col-md-6">
                      <div class="d-inline-flex me-4 mt-1">
                        <label class="c_checkbox me-2">
                          <input type="checkbox" checked="">
                          <span class="checkmark"></span>
                        </label>
                        <span>Payment terms</span>
                      </div>
                      <div class="d-inline-flex me-4 mt-1">
                        <label class="c_checkbox me-2">
                          <input type="checkbox">
                          <span class="checkmark"></span>
                        </label>
                        <span>Client notes</span>
                      </div>
                      <div class="d-inline-flex me-4 mt-1">
                        <label class="c_checkbox me-2">
                          <input type="checkbox">
                          <span class="checkmark"></span>
                        </label>
                        <span>Attach PDF in mail</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 col-md-12">
              <!-- Card: -->
              <div class="card mb-3">
                <!-- Invoice: Header-->
                <div class="card-body">
                  <div class="row justify-content-md-between">
                    <!-- Logo -->
                    <div class="col-md-4">
                      <label class="custom-file-boxed custom-file-boxed-sm" for="logoUploader">
                        <img class="avatar mb-2" src="../assets/images/logo-icon-color.svg" alt="Image Description">
                        <span class="d-block">Browse your file here</span>
                      </label>
                    </div>
                    <!-- End Logo -->

                    <div class="col-md-5 text-md-right">
                      <h3>Invoice javascript:void(0)</h3>

                      <div class="form-group">
                        <div class="input-group">
                          <input type="text" class="form-control" placeholder="" aria-label="" value="0982131">
                        </div>
                      </div>
                      <div class="input-group">
                        <textarea class="form-control" placeholder="Who is this invoice from?"
                          aria-label="Who is this invoice from?" rows="3"></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Invoice: Content -->
                <div class="card-body border-top border-bottom">
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label>Bill to:</label>
                        <textarea class="form-control" placeholder="Who is this invoice from?"
                          aria-label="Who is this invoice from?" rows="3"></textarea>
                      </div>
                    </div>

                    <div class="col-md-7 align-self-md-end">
                      <dl class="row align-items-sm-center mb-3">
                        <dt class="col-sm-4 col-md text-sm-right mb-2 mb-sm-0">Invoice date:</dt>
                        <dd class="col-sm-8 col-md-auto">
                          <div class="input-group">
                            <input data-provide="datepicker" data-date-autoclose="true" class="form-control"
                              placeholder="Select Invoice date" bsDatepicker>
                          </div>
                        </dd>
                      </dl>

                      <dl class="row align-items-sm-center">
                        <dt class="col-sm-4 col-md text-sm-right mb-2 mb-sm-0">Due date:</dt>
                        <dd class="col-sm-8 col-md-auto">
                          <div class="input-group">
                            <input data-provide="datepicker" data-date-autoclose="true" class="form-control"
                              placeholder="Select Due date" bsDatepicker>
                          </div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div class="bg-light text-dark p-2 mb-3">
                    <div class="row">
                      <div class="col-sm-5">
                        <h6 class="card-title mb-0">Item</h6>
                      </div>
                      <div class="col-sm-3 d-none d-sm-inline-block">
                        <h6 class="card-title mb-0">Quantity</h6>
                      </div>
                      <div class="col-sm-2 d-none d-sm-inline-block">
                        <h6 class="card-title mb-0">Rate</h6>
                      </div>
                      <div class="col-sm-2 d-none d-sm-inline-block">
                        <h6 class="card-title mb-0">Amount</h6>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <div class="input-group">
                          <input type="text" class="form-control mb-2" placeholder="Item name" aria-label="Item name">
                        </div>
                        <div class="input-group">
                          <input type="text" class="form-control mb-2" placeholder="Description"
                            aria-label="Description">
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-sm-auto col-md-3">
                      <!-- Quantity Counter -->
                      <div class="form-group">
                        <div class="input-group">
                          <input type="number" class="form-control" value="1">
                        </div>
                      </div>
                      <!-- End Quantity Counter -->
                    </div>

                    <div class="col-12 col-sm col-md-2">
                      <div class="form-group">
                        <div class="input-group">
                          <input type="number" class="form-control" placeholder="00" aria-label="00">
                        </div>
                      </div>
                    </div>

                    <div class="col col-md-2">
                      <div class="form-group">
                        <div class="input-group">
                          <input type="number" class="form-control mb-3" placeholder="$0.00" aria-label="$0.00">
                        </div>
                      </div>
                    </div>
                  </div>
                  <a href="javascript:;" class="btn btn-sm btn-link">Add item</a>
                </div>

                <!-- Invoice: Footer -->
                <div class="card-body">
                  <div class="row justify-content-md-end mb-3">
                    <div class="col-md-8 col-lg-7">
                      <dl class="row text-sm-right">
                        <dt class="col-sm-6">Subtotal:</dt>
                        <dd class="col-sm-6">$0.00</dd>
                        <dt class="col-sm-6">Total:</dt>
                        <dd class="col-sm-6">$0.00</dd>
                        <dt class="col-sm-6 mb-1 mb-sm-0">Tax:</dt>
                        <dd class="col-sm-6">
                          <!-- Input Group -->
                          <div class="select2-custom">
                            <div id="taxSelect" class="input-group">
                              <input type="number" class="form-control" placeholder="0.00" aria-label="0.00">
                              <div class="input-group-append">
                                <!-- Select -->
                                <select class="form-control">
                                  <option>Flat ($)</option>
                                  <option>Percent (%)</option>
                                </select>
                                <!-- End Select -->
                              </div>
                            </div>
                          </div>
                          <!-- End Input Group -->
                        </dd>
                        <dt class="col-sm-6 mb-1 mb-sm-0">Amount paid:</dt>
                        <dd class="col-sm-6">
                          <div class="form-group">
                            <div class="input-group">
                              <input type="number" class="form-control" placeholder="0.00" aria-label="0.00">
                            </div>
                          </div>
                        </dd>
                        <dt class="col-sm-6">Due balance:</dt>
                        <dd class="col-sm-6">$0.00</dd>
                      </dl>
                      <!-- End Row -->
                    </div>
                  </div>
                  <!-- Form Group -->
                  <div class="form-group">
                    <label class="input-label">Notes & terms</label>
                    <textarea class="form-control" placeholder="Who is this invoice to?"
                      aria-label="Who is this invoice to?" rows="3"></textarea>
                  </div>
                  <!-- End Form Group -->
                  <p class="font-size-sm mb-0">© Front. 2020 PuffinTheme.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
